import styles from './EFReportTable.module.scss';
import React from 'react';

export interface ReportTableProps {
  columns: string[];
  rows: {
    label: React.ReactNode;
    values: React.ReactNode[];
  }[];
}

const EFReportTable: React.FC<ReportTableProps> = ({ columns, rows }) => {
  return (
    <div className={styles.report}>
      {columns.map((column, columnIndex) => {
        const contentAreaClass =
          column === 'LV'
            ? styles.contentAreaLV
            : column === 'RV'
              ? styles.contentAreaRV
              : styles.contentArea;

        return (
        <div
          className={contentAreaClass}
          key={`${column}-${columnIndex}`}
        >
          <div className={styles.headerCells}>
            <span className={styles.title}>
              {column}
            </span>
          </div>

          {rows.map(({ label, values }, rowIndex) => {
            const isEven = rowIndex % 2 === 1;
            const rowClass =
              styles[isEven ? 'dataCells-even' : 'dataCells-body'];
            const cellValue =
              columnIndex === 0 ? label : (values[columnIndex - 1] ?? '-');

            return (
              <div className={rowClass} key={`${String(label)}-${rowIndex}`}>
                <span className={styles.title}>
                  {cellValue}
                </span>
              </div>
            );
          })}
        </div>
      )})}
    </div>
  );
};

export default EFReportTable;
